export const getIsStreamLive = (
  startTime: number,
  endTime: number,
  timeNow: number
) => {
  const isLive = startTime <= timeNow && timeNow <= endTime
  return isLive
}
